import { PRODUCT_UUID } from '../../utils/productUUIDConstants';

export const landingPageUrls = {
  [PRODUCT_UUID.BB]: 'https://www.brooksbrotherscreditcard.com/client',
  [PRODUCT_UUID.EB]: 'https://eddiebauer.imprint.co/client',
} as const;

export type LandingPageURLKey = keyof typeof landingPageUrls;

export function getLandingPageUrl(productUUID: LandingPageURLKey): string {
  return landingPageUrls[productUUID];
}

export const PARAM_IN_STORE = 'in_store';

export const PARAM_SHOW_WPP = 'showTapToPay';

// temporarily used while addToWallet is disabled
export const IMPRINT_STORE_HELP_URL = 'https://help.imprint.co/store';
